function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import PropTypes from 'prop-types';
import React from 'react';
import ReactSelect from 'react-select-plus';
import classnames from 'classnames';
import noop from 'lodash.noop';
import Close from "./Close";
import Option from "./SelectOption.js";
import SelectArrow from "./SelectArrow";
import SelectMultiValue from "./SelectMultiValue.js";

var Select =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, props);

    _this.onChange = function (value) {
      _this.setState({
        value: value
      });

      _this.props.onChange(value);
    };

    _this.bindInput = function (el) {
      _this.selectEl = el;
    };

    _this.state = {
      value: props.defaultValue
    };
    return _this;
  }

  _createClass(Select, [{
    key: "focus",
    value: function focus() {
      this.selectEl.focus();
    } //eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(props) {
      if (props.value !== this.props.value) {
        this.setState({
          value: props.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _arrowRenderer = _this$props.arrowRenderer,
          className = _this$props.className,
          inputProps = _this$props.inputProps,
          multi = _this$props.multi,
          name = _this$props.name,
          value = _this$props.value,
          valueComponent = _this$props.valueComponent,
          props = _objectWithoutProperties(_this$props, ["arrowRenderer", "className", "inputProps", "multi", "name", "value", "valueComponent"]);

      delete props.onChange; // don't pass onChange prop to react-select

      var SelectElement = ReactSelect;

      if (this.props.loadOptions && this.props.creatable) {
        SelectElement = ReactSelect.AsyncCreatable;
      } else if (this.props.loadOptions) {
        SelectElement = ReactSelect.Async;
      } else if (this.props.creatable) {
        SelectElement = ReactSelect.Creatable;
      }

      var classNames = classnames(className, {
        'select-async': this.props.loadOptions
      });
      var valueComponentRenderer = valueComponent || (multi ? SelectMultiValue : undefined);
      return (
        /*#__PURE__*/
        React.createElement(SelectElement, _extends({
          arrowRenderer: function arrowRenderer(_ref) {
            var isOpen = _ref.isOpen;
            return (
              /*#__PURE__*/
              React.createElement(SelectArrow, {
                isOpen: isOpen,
                render: _arrowRenderer
              })
            );
          },
          clearRenderer: function clearRenderer() {
            return (
              /*#__PURE__*/
              React.createElement(Close, {
                tabIndex: -1,
                style: {
                  fontSize: '1rem'
                }
              })
            );
          },
          optionComponent: Option,
          inputProps: _objectSpread({
            name: name
          }, inputProps),
          multi: multi,
          onChange: this.onChange,
          value: value || this.state.value,
          valueComponent: valueComponentRenderer,
          ref: this.bindInput,
          className: classNames,
          name: name
        }, props))
      );
    }
  }]);

  return Select;
}(React.Component);

Select.propTypes = _objectSpread({
  className: PropTypes.string,
  defaultValue: PropTypes.any,
  loadOptions: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.any
}, ReactSelect.propTypes);
Select.defaultProps = {
  onChange: noop
};
Select.displayName = "Select";
export default Select;